export const stationGames = (state, getters, rootState, rootGetters) => {
  return rootGetters['entities/StationGame'](
    ({ station, game }) => {
      const { gameId, stationId } = state;
      if (gameId) return game === gameId;
      if (stationId) return station === stationId;
    },
  );
};
